<template>
  <v-layout
    class="mt-3"
    row>
    <v-flex 
      xs12 
      md6 
      offset-md3>
      <v-hover v-if="getAllFavPosts.length === 0">
        <v-card
          slot-scope="{ hover }"
          class="mt-5 py-5 roundedcard"
          :class="`elevation-${hover ? 20 : 12}`"
          style="width: 300px; margin: auto;">
          <v-card-text class="my-5">
            <v-layout 
              row 
              wrap>
              <v-flex
                xs12>
                <!-- <v-flex class="text-xs-center">
              <span class="headline">
                Nix los
              </span>
            </v-flex> -->

                <v-flex class="mt-2 text-xs-center">
                  <v-icon
                    color="secondary"
                    size="100">
                    fas fa-narwhal
                  </v-icon>
                </v-flex>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-hover>
      <template
        v-for="(post, index) in getAllFavPosts"
        v-else>
        <v-layout 
          v-if="calcDateNew(index)"
          :key="index"
          row 
          wrap
          align-center
          class="mt-2 mx-4 text-xs-center">
          <v-flex 
            shrink 
            class="subtitle">
            <span
              style="color: #90A4AE">
              {{ displayDay(index) }}
            </span>
          </v-flex>
        </v-layout>
        <app-card-fav-event 
          v-if="post.subject === 'events'"
          :key="post.id"
          :post="post"
          justify-center
          style=" margin: auto;">
        </app-card-fav-event>
        <app-card-fav-moment 
          v-if="post.subject === 'moments'"
          :key="post.id"
          :post="post"
          justify-center
          style="margin: auto;">
        </app-card-fav-moment>
      </template>
    </v-flex> 
  </v-layout>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'

import CardFavEvent     from '@/components/View_Favorites/Card_FavEvent.vue'
import CardFavMoment    from '@/components/View_Favorites/Card_FavMoment.vue'

export default {
  components: {
    // eslint-disable-next-line
    "app-card-fav-event": CardFavEvent,
    // eslint-disable-next-line
    "app-card-fav-moment": CardFavMoment,
   
  },
  

  
  computed: {
    ...mapState({
      isMobile: state => state.isMobile,
    }),
    ...mapGetters({
      getAllFavPosts: 'getAllFavPosts',
    }),
    
  },
  created() {
    this.loadFavMoments()
    this.loadFavEvents()
  },
  methods: {
    ...mapActions([
      'loadFavMoments',
      'loadFavEvents',
    ]),

    calcDateNew(index) {
      if (index === 0) {
        return true
      } else if (this.displayDay(index) !== this.displayDay(index - 1)) {
        return true
      } else {
        return false
      }
    },


    displayDay(index) {
      if (new Date(this.getAllFavPosts[index].date).toISOString() < new Date().toISOString()) {
        return 'Die letzen 24 h'
      } else if (new Date(this.getAllFavPosts[index].date).toLocaleDateString(this.locale) === new Date().toLocaleDateString(this.locale)) {
        return 'Heute'
      } else  {
        return this.$options.filters.date(new Date(this.getAllFavPosts[index].date)) 
      }

    },
  },
}
</script>


<style lang="scss" scoped>

.dateline {
  border: 1px solid #CFD8DC;
}
</style>
